import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/NotVerified.css";

const NotVerified = () => {
  const navigate = useNavigate();

  const handleCompleteProfile = () => {
    navigate("/my-profile");
  };

  return (
    <div className="not-verified">
      <div className="verification-content">
        <div className="verification-icon">
          <svg
            width="80"
            height="80"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z"
              fill="#fbbf24"
            />
            <path
              d="M12 6L13.09 10.26L16 11L13.09 11.74L12 16L10.91 11.74L8 11L10.91 10.26L12 6Z"
              fill="#f59e0b"
            />
          </svg>
        </div>

        <h1 className="verification-title">Account Not Verified</h1>

        <div className="verification-message">
          <p className="main-message">
            You are not verified yet. Complete your organizer profile and upload
            documents to get verified.
          </p>
          <p className="sub-message">
            Kindly wait until we review and verify your account.
          </p>
        </div>

        <div className="verification-steps">
          <div className="step">
            <div className="step-number">1</div>
            <div className="step-content">
              <h4>Complete Your Profile</h4>
              <p>Fill in all required information in your organizer profile</p>
            </div>
          </div>

          <div className="step">
            <div className="step-number">2</div>
            <div className="step-content">
              <h4>Upload Documents</h4>
              <p>Submit necessary documents for verification</p>
            </div>
          </div>

          <div className="step">
            <div className="step-number">3</div>
            <div className="step-content">
              <h4>Wait for Review</h4>
              <p>Our team will review your application within 24-48 hours</p>
            </div>
          </div>
        </div>

        <button className="complete-profile-btn" onClick={handleCompleteProfile}>
          Complete Profile
        </button>

        <div className="contact-support">
          <p>
            Need help?{" "}
            <a href="/contact-support" className="support-link">
              Contact Support
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotVerified;